import List from './List';
import Create from './Create';
import Edit from './Edit';


export {
  List,
  Create,
  Edit,
};



// WEBPACK FOOTER //
// ./src/components/PrivateQuote/index.js